import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import QrReader from "react-qr-reader-es6";

const QRScannerModal = ({ show, onHide, onScan }) => {
  const [manualCode, setManualCode] = useState("");
  const [cameraError, setCameraError] = useState(null);

  const handleScan = (data) => {
    if (data) {
      onScan(data);   // devolvemos el claimCode al padre
      onHide();       // cerramos modal
    }
  };

  const handleError = (err) => {
    console.error("Error escaneando QR:", err);
    setCameraError("No se pudo acceder a la cámara. Usá la carga manual.");
  };

  const handleManualSubmit = () => {
    if (manualCode.trim()) {
      onScan(manualCode.trim());
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Escanear QR</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!cameraError ? (
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: "100%" }}
          />
        ) : (
          <Alert variant="warning">{cameraError}</Alert>
        )}

        <hr />
        <Form.Group>
          <Form.Label>Ingresar código manual</Form.Label>
          <Form.Control
            type="text"
            placeholder="Ej: BEN-1-40-11efd1b6"
            value={manualCode}
            onChange={(e) => setManualCode(e.target.value)}
          />
          <Button
            variant="primary"
            className="mt-2"
            onClick={handleManualSubmit}
            disabled={!manualCode.trim()}
          >
            Validar QR Manual
          </Button>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QRScannerModal;
